import { PrimaryScene } from "app/common/types"

function getUtmCampaign(): string | null {
    const utm = document.cookie.split(";")
        .filter(cookie => /^utm=.*campaign/i.test(cookie.trim()))[0]

    if (!utm) {
        return null
    }

    const utmString = utm.split("=")[1]

    if (!utmString) {
        return null
    }

    try {
        const utm = JSON.parse(decodeURIComponent(utmString))
        return utm.campaign
    } catch (e) {
        return null
    }
}

const campaignToSceneMap: Record<string, PrimaryScene> = {
    "minjiekaifa-5.15": PrimaryScene.rd,
    ceshi: PrimaryScene.testing,
    chanpintuandui: PrimaryScene.rd,
    jiaoyuxingye: PrimaryScene.education,
    keyanguanli: PrimaryScene.research,
    mubiaoguanli: PrimaryScene.objective,
    shichangtuandui: PrimaryScene.marketing,
    xiangmuguanli: PrimaryScene.project,
    xiezuoguanli: PrimaryScene.cooperation,
}

const pathToSceneMap: Record<string, PrimaryScene> = {
    agile: PrimaryScene.develop,
    design: PrimaryScene.design,
    education: PrimaryScene.education,
    manageproject: PrimaryScene.project,
    manufacture: PrimaryScene.manufacturing,
    marketing: PrimaryScene.marketing,
    pm: PrimaryScene.rd,
    retail: PrimaryScene.retail,
    securities: PrimaryScene.finance,
    testing: PrimaryScene.testing,
    hr: PrimaryScene.operations,
}

export function getPrimarySceneFromUrlPath(): null | PrimaryScene {
    const path = location.pathname.replace("/", "")
    return pathToSceneMap[path] || null
}

export function getPrimarySceneFromUtm(): null | PrimaryScene {
    const campaign = getUtmCampaign()

    if (!campaign) {
        return null
    }

    const scene = campaignToSceneMap[campaign]
    return scene || null
}
